module.exports = __webpack_public_path__ + "static/media/client-asus.81e97cb7.jpg";